import { useTrpc, type RouterInput, type RouterOutput } from '#composables/useTrpc';

export type UserType = RouterOutput['core']['user']['getMe'];
type SaveUserSettingsInput = RouterInput['core']['user']['saveUserSettings'];
type createUserAccessInput = RouterInput['core']['user']['createUserAccessRequest'];

export async function getMe() {
  return useTrpc().core.user.getMe.query();
}

export async function getDefaultAccessRequest() {
  return useTrpc().core.user.getDefaultAccessRequest.query();
}

export async function saveUserSettings(input: SaveUserSettingsInput) {
  return useTrpc().core.user.saveUserSettings.mutate(input);
}

export async function createUserAccessRequest(input: createUserAccessInput) {
  return useTrpc().core.user.createUserAccessRequest.mutate(input);
}
